import React from 'react';

import { Box, Typography } from '@mui/material';

import { ValueStub } from 'constants/data';
import { alwaysTrue } from 'utils/data';

import { SlaLevelColumnId, slaTableWidthMap } from './SlaGroupInfoModal.constants';
import { deletedTextStyles } from './SlaGroupInfoModal.styles';
import SlaTypeCell from './SlaTypeCell';

const renderSignersCell = ({ value, deletedValue }) => (
  <Box>
    <Typography variant="regular16">{value || ValueStub.ALTERNATE}</Typography>
    {deletedValue && (
      <Typography component="p" sx={deletedTextStyles} variant="regular16">
        Deleted: {deletedValue}
      </Typography>
    )}
  </Box>
);

const getRowStyles = ({ _rowStyles }) => _rowStyles;

export const slaTableConfig = {
  [SlaLevelColumnId.TYPE]: {
    label: 'SLA Level',
    width: slaTableWidthMap[SlaLevelColumnId.TYPE],
    customStyles: getRowStyles,
    content: ({ _level }) => <SlaTypeCell level={_level} />,
  },
  [SlaLevelColumnId.SLA]: {
    label: 'SLA',
    width: slaTableWidthMap[SlaLevelColumnId.SLA],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [SlaLevelColumnId.SLA]: cellData }) => cellData,
  },
  [SlaLevelColumnId.POTENTIAL_SIGNERS]: {
    label: 'Potential Users',
    width: slaTableWidthMap[SlaLevelColumnId.POTENTIAL_SIGNERS],
    customStyles: getRowStyles,
    content: ({ [SlaLevelColumnId.POTENTIAL_SIGNERS]: value, _deletedPotential }) =>
      renderSignersCell({ value, deletedValue: _deletedPotential }),
  },
  [SlaLevelColumnId.ACTUAL_SIGNERS]: {
    label: 'Users to Complete',
    width: slaTableWidthMap[SlaLevelColumnId.ACTUAL_SIGNERS],
    customStyles: getRowStyles,
    content: ({ [SlaLevelColumnId.ACTUAL_SIGNERS]: value, _deletedActual }) =>
      renderSignersCell({ value, deletedValue: _deletedActual }),
  },
  [SlaLevelColumnId.SLA_TYPE]: {
    label: 'Type',
    width: slaTableWidthMap[SlaLevelColumnId.SLA_TYPE],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [SlaLevelColumnId.SLA_TYPE]: cellData }) => cellData || ValueStub.ALTERNATE,
  },
  [SlaLevelColumnId.ELIGIBLE_FOR_SIGN_OFF_DATE]: {
    label: 'SLA Start Date/Time',
    width: slaTableWidthMap[SlaLevelColumnId.ELIGIBLE_FOR_SIGN_OFF_DATE],
    customStyles: getRowStyles,
    renderContentAsText: alwaysTrue,
    content: ({ [SlaLevelColumnId.ELIGIBLE_FOR_SIGN_OFF_DATE]: cellData }) => cellData,
  },
};
